
import BaseFactory from './BaseFactory';
import ClassCollection from './index';

export default class Factory extends BaseFactory {

    /**
     *
     * @param opts
     * @param opts.map
     * @param opts.basicComponents
     * @param opts.config
     */
    constructor(opts: any) {
        super(opts);
    }
    /**
     * 创建组件
     * @param opts {Object}
     */
    public createComponents(opts: any = {}) {
        const ClassCol: any = ClassCollection;
        for (const key in ClassCol) {
            if (ClassCol.hasOwnProperty(key)) {
                const comp = ClassCol[key];
                this.components[key] = new comp(this.options);
                this.components[key] = this.components[key].initComponents();
            }
        }
    }
}
